/**
 * Enum that identifies the two ordering options, ascending or descending.
 */
export enum SqlOrder {
  /** Request the dataset results in ascending order. */
  ASC = 'ASC',
  /** Request the dataset results in descending order. */
  DESC = 'DESC'
}
